export default __webpack_public_path__ + "static/media/bank-not-found.8d5de16d.png";